import { InvoiceRow } from "@wingspanhq/wingspan-api-sdk";

/**
 * Resolve the client (payer) display names for an invoice search row. On v3 the
 * denormalized identity lives in `row.profile` (+ `row.email`) rather than the
 * v1 embedded `client`/`clientName`/`clientCompany` fields.
 */
export const selectorInvoiceRowClientName = (invoice: InvoiceRow) => {
  const profile = invoice.profile;
  const fullName = [profile?.firstName, profile?.lastName]
    .filter(Boolean)
    .join(" ");

  const name =
    profile?.companyName ||
    profile?.displayName ||
    profile?.doingBusinessAs ||
    fullName ||
    undefined;

  const email = invoice.email ?? undefined;

  const primaryName = name || email;
  const secondaryName = name ? email : undefined;

  return {
    primaryName,
    secondaryName
  };
};
